import React from 'react';
import { Box, Typography, Button, IconButton, Stack, Paper } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import ShapeLineOutlinedIcon from '@mui/icons-material/ShapeLineOutlined';
import TextFieldOutlinedIcon from '@mui/icons-material/TextFieldsOutlined';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';


export default function LeftSidebar({ onAddElement, showIcons }) {
  const tools = [
    { type: 'image', icon: <ImageOutlinedIcon />, label: 'Image' },
    { type: 'shape', icon: <ShapeLineOutlinedIcon />, label: 'Shape' },
    { type: 'text', icon: <TextFieldOutlinedIcon />, label: 'Text' },
    { type: 'qr', icon: <QrCode2OutlinedIcon />, label: 'QR' },
    { type: 'line', icon: <HorizontalRuleIcon />, label: 'Line' },
    ...(showIcons ? [{ type: 'labels', icon: <AppsOutlinedIcon />, label: 'Icons' }] : []),
  ];

  return (
    <Box
      sx={{
        position: 'relative',
        width: 256,
        bgcolor: '#313131',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100vh',
        overflowY: 'auto'
      }}
    >
      
      {/* Add Components Section */}
      <Box sx={{ width: '100%', p: 2, px: 4 }}>
        <Typography 
          variant="caption" 
          fontWeight="bold" 
          letterSpacing={1.5} 
          sx={{ color: 'white', mb: 2, display: 'block' }}
        >
          ADD COMPONENTS
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 2, 
          }}
        >
          {tools.map(tool => (
            <Button
              key={tool.type}
              onClick={() => onAddElement(tool.type)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                color: 'white',
                minWidth: 0,
                p: 1,
                borderRadius: 2,
                '&:hover': {
                  bgcolor: '#4a4a4a',
                }
              }}
            >
              <Box sx={{ fontSize: '2rem', mb: 0.5 }}>{tool.icon}</Box>
              <Typography variant="body2" sx={{ fontSize: '0.7rem' }}>{tool.label}</Typography>
            </Button>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
